import {
  BulkDoctorInvitationRequest,
  DoctorInvitationDto,
  DoctorInvitationEventDto,
  DoctorInvitationRequest,
} from "../types/doctorInvitation.definition";
import {
  cancelInvitation,
  getAllInvitations,
  getInvitationEvents,
  inviteDoctor,
  inviteDoctorsBulk,
  resendInvitation,
} from "../webclients/doctorInvitation.client";

export const doctorInvitationApi = {
  inviteDoctor: async (
    data: DoctorInvitationRequest
  ): Promise<DoctorInvitationDto> => {
    const response = await inviteDoctor(data);
    return response.data;
  },
  inviteDoctorsBulk: async (
    data: BulkDoctorInvitationRequest
  ): Promise<DoctorInvitationDto[]> => {
    const response = await inviteDoctorsBulk(data);
    return response.data;
  },
  resendInvitation: async (id: number): Promise<DoctorInvitationDto> => {
    const response = await resendInvitation(id);
    return response.data;
  },
  getAllInvitations: async (): Promise<DoctorInvitationDto[]> => {
    const response = await getAllInvitations();
    return response.data;
  },
  cancelInvitation: async (id: number): Promise<void> => {
    await cancelInvitation(id);
  },
  getInvitationEvents: async (
    id: number
  ): Promise<DoctorInvitationEventDto[]> => {
    const response = await getInvitationEvents(id);
    return response.data;
  },
};

export default doctorInvitationApi;
